<div class="row">
  <div class="col-xs-12">
    <ui-panel>
      <h1>View2 Component Works !</h1>
      <p>This page is simply for more content...</p>
    </ui-panel>
  </div>
</div>
